module.exports = __webpack_public_path__ + "static/img/null-store-icon_light.442df916.png";